import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useParams } from "react-router-dom";
import { IMAGEAPI } from '../../BackendConnections';
import {
    sendSuggestedConnectionAction,
    withDrawPedingConnectionAction,
    sendProfileConnectionRequestAction,
    withDrawProfileConnectionAction,
    sendMyPofileAction,
    removeMyProfileAction
} from '../../redux/actions/network/networkAction';
import axiosInstance from '../authentication/helper/axiosApi';
import UserLayout from '../utils/user/UserLayout'
import PdfResume from './helper/CV/PdfResume';


export const Contacts = (props) => {
    const params = useParams();
    const [contact, setContact] = useState([]);
    const [pdfData, setPdfData] = useState([]);

    const [data, setData] = useState({
        is_contact: false,
        is_pdf_data: false
    })

    const handleSendconnection = () => {
        const connection = [
            {
                id: contact[0].id,
                profile_pic: contact[0].profile_pic,
                location: contact[0].location,
                primary_job_title: contact[0].primary_job_title,
                userId: contact[0].userId,
                mutual_connections: contact[0].mutual_connections,
                sender: [],
                company_name: contact[0].company_name,
            },
        ];

        const data = {
            receiver: contact[0].id,
        };

        props.sendConnection(connection, data);
        const values = [...contact];
        values[0]["is_active"] = true
        setContact(values)
    };

    const handlewithdrawConnection = () => {
        const connection = [
            {
                id: contact[0].id,
                profile_pic: contact[0].profile_pic,
                location: contact[0].location,
                primary_job_title: contact[0].primary_job_title,
                userId: contact[0].userId,
                mutual_connections: contact[0].mutual_connections,
                sender: [],
                company_name: contact[0].company_name,
            },
        ];

        const data = {
            receiver: contact[0].id,
        };

        props.withdrawConnection(connection, data);
        const values = [...contact];
        values[0]["is_active"] = false
        setContact(values)
    };

    const handleSendProfileconnection = (profileId) => {
        const data = {
            receiver: profileId,
        };
        props.sendProfileConnection(data)
        const values = [...contact];
        values[0]["is_accept_pdf"] = true
        setContact(values)
    };

    const handleWithdrawProfileConnection = () => {
        const data = {
            receiver: params.id,
        };
        props.withdrawProfileConnection(params.id, data);
        const values = [...contact];
        values[0]["is_accept_pdf"] = false
        setContact(values)
    };

    const handleRemoveMyProfile = () => {
        const receiver = {
            receiver: params.id,
        };
        props.removeMyProfile(receiver)
        const values = [...contact];
        values[0]["is_profile_sent"] = false
        setContact(values)
    };

    const handleSendMyProfile = (profileId) => {
        props.sendMyProfile(profileId)
        const values = [...contact];
        values[0]["is_profile_sent"] = true
        setContact(values)
    }


    useEffect(() => {
        if (Object.keys(props.profile).length > 0 && data.is_contact === false) {
            axiosInstance.get(`api/network/contact/${params.id}/`)
                .then(function (response) {
                    setData((prevState) => ({ ...prevState, is_contact: true }));
                    setContact([response.data]);
                });
        }

        if (Object.keys(props.profile).length > 0 && data.is_pdf_data === false) {
            axiosInstance.get(`api/network/userProfilePdf/${params.id}/`)
                .then(function (response) {
                    setData((prevState) => ({ ...prevState, is_pdf_data: true }));
                    setPdfData(response.data);
                });
        }


    }, [props, params.id])

    


    return (
        <div className="mynetwork-page">
            <UserLayout>
            <style>
  {`
   .profile-hexagon {
    width: 150px;
    height: 130px; /* This height may need to be adjusted to maintain the aspect ratio for equal sides */
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    clip-path: polygon(
      25% 0%, 
      75% 0%, 
      100% 50%, 
      75% 100%, 
      25% 100%, 
      0% 50%
    );
  }
  
  `}
</style>

           
                {contact &&
                    contact.map((row, index) => {
                        return (
                            <div className="right-section">
                                <div className="row">
                                    <div className="col-lg-7 col-md-6 col-12">
                                        <div className="inner-content primary-content">
                                            <div className="page-title 
                                            ">
                                                <h2>
                                                    <strong>{row.first_name} </strong>
                                                    {row.last_name}
                                                </h2>
                                                <span className="ni nicon-network">
                                                {/* <hr style={{height: "5px" ,background: "#2f9cca", width: "30%"}}></hr> */}

                                                </span>
                                            </div>
                                            <p className='mt-3'>
                                                <h6>
                                                    {row.primary_job_title} - {row.company_name}
                                                </h6>
                                                <h6>{row.mutual_connections} mutual connections</h6>
                                            </p>
                                            <br></br>
                                            <p>
                                                <div className="cmb-25" style={{ float: "left" }}>
                                                    {row.is_profile_accepted ? '' :

                                                        row.is_accept_pdf ? (
                                                            <button
                                                                type="submit"
                                                                onClick={() => handleWithdrawProfileConnection()}
                                                                className=" btn btn-blue"
                                                            >
                                                                Withdraw Profile Request
                                                            </button>
                                                        ) : (
                                                            <button
                                                                type="submit"
                                                                onClick={() => handleSendProfileconnection(row.id)}
                                                                className=" btn btn-blue"
                                                            >
                                                                Profile Request
                                                            </button>
                                                        )

                                                    }
                                                    &nbsp;
                                                    {row.is_profile_sent ?
                                                        <button
                                                            type="submit"
                                                            onClick={() => handleRemoveMyProfile()}
                                                            className=" btn btn-blue"
                                                        >
                                                            Remove My Profile
                                                        </button>
                                                        :
                                                        <button
                                                            type="submit"
                                                            onClick={() => handleSendMyProfile(row.id)}
                                                            className=" btn btn-blue"
                                                        >
                                                            Send My Profile
                                                        </button>
                                                    }

                                                    &nbsp;
                                                    {row.is_connected ? '' : row.is_active ? (
                                                        <button
                                                            type="submit"
                                                            onClick={() => handlewithdrawConnection()}
                                                            className=" btn btn-blue"
                                                        >
                                                            Withdraw Connection
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="submit"
                                                            onClick={() => handleSendconnection()}
                                                            className=" btn btn-blue"
                                                        >
                                                            Connect
                                                        </button>
                                                    )}
                                                </div>
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div className="col-lg-5 col-md-6 col-12">
                                    <div
                    className="profile-hexagon"
                    style={{ backgroundImage: `url(${IMAGEAPI + row.profile_pic})` }}
                  />
                  
                                      
                                    </div>

                                    



                                </div>


                                <div className="row connection-request-section">
                                    <div className="col-12">
                                        <div className="border-box">
                                            <div className="row small-gutter">

                                            <div className="col-12">
    {row.is_profile_accepted ? (
        <PdfResume data={pdfData} />
    ) : (
        <p style={{ textAlign: "center", fontSize: '19px' /* Add your desired font-size value */ }}>
            You have to send a profile request to view , &nbsp;
            {row.first_name} {row.last_name}'s profile
        </p>
    )}
</div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </UserLayout>
        </div>
    )
}

const mapStateToProps = (state) => {
    const user = state.user.user;
    const profile = state.user.profile;

    return {
        user: user,
        profile: profile,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        sendConnection: (receiver, data) => dispatch(sendSuggestedConnectionAction(receiver, data)),
        withdrawConnection: (receiver, data) => dispatch(withDrawPedingConnectionAction(receiver, data)),

        sendProfileConnection: (data) => dispatch(sendProfileConnectionRequestAction(data)),
        withdrawProfileConnection: (id, data) => dispatch(withDrawProfileConnectionAction(id, data)),
        sendMyProfile: (profileId) => dispatch(sendMyPofileAction(profileId)),
        removeMyProfile: (data) => dispatch(removeMyProfileAction(data))
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Contacts)